// extracted by mini-css-extract-plugin
export default {"heading":"Navbar_heading__uWFDi"};